// extracted by mini-css-extract-plugin
export default {"sidePanel":"sidepanel_sidePanel__wZYQH","left":"sidepanel_left__q1UvJ","right":"sidepanel_right__c+z-Q","top":"sidepanel_top__mLbxn","bottom":"sidepanel_bottom__F2x6s"};